import React from 'react';
import trashIcon from '../../assets/trash.svg';
import './DeleteProjectModal.css';

const DeleteProjectModal = ({ isOpen, onClose, onConfirm, project, loading = false }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && !loading) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (!loading && onConfirm) {
            onConfirm();
        }
    };

    return (
        <div className="delete-project-modal-overlay" onClick={handleBackdropClick}>
            <div className="delete-project-modal">
                <button
                    className="delete-project-modal-close"
                    onClick={onClose}
                    disabled={loading}
                    aria-label="Close"
                >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>

                <div className="delete-project-modal-header">
                    <div className="delete-project-modal-header-left">
                        <img src={trashIcon} alt="Delete" className="delete-project-modal-small-icon" />
                        <h2 className="delete-project-modal-title">Delete Project</h2>
                    </div>
                </div>

                <p className="delete-project-modal-description">
                    Are you sure you want to delete this project? This action can't be undone.
                </p>

                <div className="delete-project-modal-actions">
                    <button
                        className="delete-project-modal-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="delete-project-modal-delete"
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteProjectModal;
